export class GetTableDataQualityEventTimeHistogramResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketSeconds",
            "baseName": "bucketSeconds",
            "type": "number",
            "format": "double"
        },
        {
            "name": "buckets",
            "baseName": "buckets",
            "type": "Array<TableEventTimeBucket>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityEventTimeHistogramResponse.attributeTypeMap;
    }
    constructor() {
    }
}
